
import Roles from '../views/Admin/Roles/Roles.vue'
import CreateRole from '../views/Admin/Roles/CreateRole.vue'
import EditRole from '../views/Admin/Roles/EditRole.vue'

const rolesRoutes = [
    
      {
        path: '/Roles',
        name: 'Roles',
        component: Roles,
        meta: { requiresAuth: true, permissions: ["view_roles"] }, 
      },
    
      {
        path: '/Roles/Create',
        name: 'RolesCreate',
        component: CreateRole,
        meta: { requiresAuth: true, permissions: ["add_roles"] }, 
      },
    
      {
        path: '/Roles/Edit/:id',
        name: 'RolesEdit',
        component: EditRole,
        prop: route => ({ type: 'edit', id: route.params.id }),
        meta: { requiresAuth: true, permissions: ["edit_roles"] }, 
      },
];

export default rolesRoutes;
